export default {
    MAX_NUMBER: 35,
    NO_COLOR_FLAG: 'nocolor',
};
